import React from "react";
import useStyles from "./styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const HeaderPage = () => {
	const classes = useStyles();
	const history = useHistory();

	return (
		<Grid classes={{ root: classes.root }} id="headerPage">
			<Grid classes={{ root: classes.header }}>
				<Grid
					classes={{ root: classes.btnBack }}
					onClick={() => {
						history.goBack();
					}}
				>
					<ArrowBackIcon />
				</Grid>
				<Grid classes={{ root: classes.title }}>Trò chơi</Grid>
			</Grid>
		</Grid>
	);
};

export default HeaderPage;
